/* eslint-disable */
import React from 'react';
import SelectInput from '../select_input/SelectInput.jsx';
import { COHATCH_MARKETS, COHATCH_LOCATIONS, MEMBERSHIP_TYPES, } from "../../constant.js";


const COhatchMembershipTermsForm = ({
    companyName, setCompanyName,
    primaryPhone, setPrimaryPhone,
    dateOfBirth, setDateOfBirth,
    market, setMarket,
    location, setLocation,
    membershipType, setMembershipType,
    addOns, setAddOns,
    membershipStartDate, setMembershipStartDate,
    initialMembershipTerm, setInitialMembershipTerm,
    assignedPrivateOffice, setAssignedPrivateOffice,
    nonRefundableFee, setNonRefundableFee,
    officeDeposit, setOfficeDeposit,
    totalDueStart, setTotalDueStart,
    totalDueMonthly, setTotalDueMonthly,
    addendum, setAddendum,
}) => {

    return (
        <>
            {/* Company Name */}
            <div>
                <label htmlFor="companyName" className="block text-sm font-semibold text-gray-700">Company Name <span className="text-danger-500">*</span></label>
                <input
                    onChange={(event) => setCompanyName(event.target.value)}
                    value={companyName}
                    id="companyName"
                    name="companyName"
                    type="text"
                    className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
                />
            </div>

            {/* Grid Layout for shorter fields */}
            <div className="grid grid-cols-2 gap-4">
                {/* Primary Phone Number */}
                <div>
                    <label htmlFor="primaryPhone" className="block text-sm font-semibold text-gray-700">
                        Primary Phone Number <span className="text-danger-500">*</span>
                    </label>
                    <input
                        onChange={(event) => {
                            // Allow only digits and certain formatting characters (e.g., (, ), -, space)
                            const value = event.target.value.replace(/[^0-9\(\)\-\s]/g, ''); // Allow digits, (, ), -, and space
                            setPrimaryPhone(value);
                        }}
                        value={primaryPhone}
                        id="primaryPhone"
                        name="primaryPhone"
                        type="text"
                        required
                        className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
                    />
                </div>


                {/* Date of Birth */}
                <div>
                    <label htmlFor="dateOfBirth" className="block text-sm font-semibold text-gray-700">Date of Birth <span className="text-danger-500">*</span></label>
                    <input
                        type="date"
                        onChange={(e) => setDateOfBirth(e.target.value)}
                        value={dateOfBirth}
                        required
                        className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
                    />
                </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
                {/* Membership Type */}
                <div>
                    <label className="block text-sm font-semibold text-gray-700">Membership Type <span className="text-danger-500">*</span></label>
                    <SelectInput
                        options={MEMBERSHIP_TYPES}
                        value={MEMBERSHIP_TYPES.find((item) => item.value === membershipType)}
                        setSelectedValue={(selected) => setMembershipType(selected.value)}
                        placeholder="Choose a membership type"
                        className="mt-1"
                        required
                    />
                </div>

                {/* Membership Start Date */}
                <div>
                    <label htmlFor="membershipStartDate" className="block text-sm font-semibold text-gray-700">Membership Start Date <span className="text-danger-500">*</span></label>
                    <input
                        type="date"
                        onChange={(e) => setMembershipStartDate(e.target.value)}
                        value={membershipStartDate}
                        required
                        className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
                    />
                </div>
            </div>


            {/* Home Market and Location (Grid) */}
            <div className="grid grid-cols-2 gap-4">
                {/* Home Market Dropdown */}
                <div>
                    <label className="block text-sm font-semibold text-gray-700">Select COhatch Market <span className="text-danger-500">*</span></label>
                    <SelectInput
                        options={COHATCH_MARKETS.market}
                        value={COHATCH_MARKETS.market.find((item) => item.value === market)}
                        setSelectedValue={(selected) => {
                            setMarket(selected.value);
                            setLocation(""); // Reset location when market changes
                        }}
                        placeholder="Choose a market"
                        className="mt-1"
                        required
                    />
                </div>

                {/* Home Location Dropdown */}
                {market && (
                    <div>
                        <label className="block text-sm font-semibold text-gray-700">Select COhatch Location <span className="text-danger-500">*</span></label>
                        <SelectInput
                            options={COHATCH_LOCATIONS.cities[0][market]?.locations || []}
                            value={location ? COHATCH_LOCATIONS.cities[0][market]?.locations.find((item) => item.value === location) : ""}
                            setSelectedValue={(selected) => setLocation(selected.value)}
                            placeholder="Choose a location"
                            className="mt-1"
                            required
                        />
                    </div>
                )}

            </div>

            <div className="grid grid-cols-2 gap-4">
                {/* Add-Ons */}
                <div>
                    <label htmlFor="addOns" className="block text-sm font-semibold text-gray-700">Add-Ons (optional)</label>
                    <input
                        onChange={(e) => setAddOns(e.target.value)}
                        value={addOns}
                        id="addOns"
                        name="addOns"
                        type="text"
                        className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
                    />
                </div>

                {/* Initial Membership Term */}
                <div>
                    <label htmlFor="initialMembershipTerm" className="block text-sm font-semibold text-gray-700">Initial Membership Term (optional)</label>
                    <input
                        onChange={(e) => setInitialMembershipTerm(e.target.value)}
                        value={initialMembershipTerm}
                        id="initialMembershipTerm"
                        name="initialMembershipTerm"
                        type="text"
                        className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
                    />
                </div>
            </div>

            {/* Remaining Fields */}
            <div className="grid grid-cols-2 gap-4">
                {/* Assigned Private Office/Desk */}
                <div>
                    <label className="block text-sm font-semibold text-gray-700">
                        Assigned Private Office/Desk at Home Location (Optional)
                    </label>
                    <div className="mt-2 flex items-center space-x-6">
                        <label className="inline-flex items-center">
                            <input
                                type="radio"
                                name="assignedPrivateOffice"
                                value="yes"
                                checked={assignedPrivateOffice === "Yes"}
                                onChange={() => setAssignedPrivateOffice("Yes")}
                                className="text-primary-600 border-gray-300"
                            />
                            <span className="ml-2 text-gray-700">Yes</span>
                        </label>
                        <label className="inline-flex items-center">
                            <input
                                type="radio"
                                name="assignedPrivateOffice"
                                value="no"
                                checked={assignedPrivateOffice === "No"}
                                onChange={() => setAssignedPrivateOffice("No")}
                                className="text-primary-600 border-gray-300"
                            />
                            <span className="ml-2 text-gray-700">No</span>
                        </label>
                    </div>
                </div>


                {/* Non-Refundable Start-up Fee */}
                <div>
                    <label htmlFor="nonRefundableFee" className="block text-sm font-semibold text-gray-700">
                        Non-Refundable Start-Up Fee <span className="text-danger-500">*</span>
                    </label>
                    <div className="relative">
                        <span className="absolute left-3 top-2.5 text-gray-500">$</span>
                        <input
                            type="text"
                            onChange={(e) => {
                                // Validate input to allow only digits and decimals
                                const regex = /^[0-9]*\.?[0-9]*$/;
                                const value = e.target.value;
                                if (regex.test(value) || value === "") {
                                    setNonRefundableFee(value);
                                }
                            }}
                            value={nonRefundableFee}
                            required
                            className="mt-1 pl-6 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
                        />
                    </div>
                </div>

            </div>

            {/* Deposit and Total Due at Start */}
            <div className="grid grid-cols-2 gap-4">
                {/* Office Deposit */}
                <div>
                    <label htmlFor="officeDeposit" className="block text-sm font-semibold text-gray-700">
                        Private Office/Reserved Desk Deposit (Optional)
                    </label>
                    <div className="relative">
                        <span className="absolute left-3 top-2.5 text-gray-500">$</span>
                        <input
                            type="text"
                            onChange={(e) => {
                                // Allow only numbers and a single decimal point
                                const value = e.target.value;
                                if (/^\d*\.?\d*$/.test(value)) {
                                    setOfficeDeposit(value);
                                }
                            }}
                            value={officeDeposit}
                            className="mt-1 pl-6 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
                        />
                    </div>
                </div>

                {/* Total Due at Start */}
                <div>
                    <label htmlFor="totalDueStart" className="block text-sm font-semibold text-gray-700">
                        Total Due at Start of Membership <span className="text-danger-500">*</span>
                    </label>
                    <div className="relative">
                        <span className="absolute left-3 top-2.5 text-gray-500">$</span>
                        <input
                            type="text"
                            onChange={(e) => {
                                // Allow only numbers and a single decimal point
                                const value = e.target.value;
                                if (/^\d*\.?\d*$/.test(value)) {
                                    setTotalDueStart(value);
                                }
                            }}
                            value={totalDueStart}
                            required
                            className="mt-1 pl-6 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
                        />
                    </div>
                </div>
            </div>

            {/* Total Due Monthly */}
            <div>
                <label htmlFor="totalDueMonthly" className="block text-sm font-semibold text-gray-700">
                    Total Due Each Subsequent Month ("Membership Fees") <span className="text-danger-500">*</span>
                </label>
                <div className="relative">
                    <span className="absolute left-3 top-2.5 text-gray-500">$</span>
                    <input
                        type="text"
                        onChange={(e) => {
                            // Allow only numbers and a single decimal point
                            const value = e.target.value;
                            if (/^\d*\.?\d*$/.test(value)) {
                                setTotalDueMonthly(value);
                            }
                        }}
                        value={totalDueMonthly}
                        required
                        className="mt-1 pl-6 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
                    />
                </div>
            </div>

            {/* Addendum */}
            <div className="mt-4">
                <label htmlFor="addendum" className="block text-sm font-semibold text-gray-700">
                    Addendum (Optional)
                </label>
                <input
                    type="text"
                    onChange={(e) => setAddendum(e.target.value)}
                    value={addendum}
                    className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm focus:ring-primary-400 focus:border-primary-400"
                />
            </div>
        </>
    );
};

export default COhatchMembershipTermsForm;
